export default __webpack_public_path__ + "maps-examples-default-styles-thumbnail-480-df952cdb86234774a7e5106835d10d8a.png";